import styled from 'styled-components';

export const $ReferenceListPopover = styled.div`
  font-family: ${props => props.theme.fontFamily};
  background-color: white;
  font-size: ${props => props.theme.fontSize}px;
  box-shadow: ${props => props.theme.boxShadow};
  border-radius: ${props => props.theme.borderRadius}px;
  display: flex;
  flex-direction: column;
  padding: 4px;
`;

export const $ReferenceListItem = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 8px;
  line-height: 22px;
  min-height: 28px;
  border-radius: ${props => props.theme.borderRadius}px;
  /* Label lunghe (anche codici senza spazi) vanno a capo senza sovrapporsi */
  overflow-wrap: anywhere;

  & > .ant-space {
    max-height: none;
  }

  &.option {
    cursor: pointer;
  }

  &.selected {
    background-color: ${props => props.theme.colorBgLayout};
    color: ${props => props.theme.colorPrimary};
  }
`;
